import { createSlice } from "@reduxjs/toolkit";
import { deleteCompanyInfo, deleteImageFromCompanyInfo, getCompanyInfo, upsertCompanyInfo } from "./Thunk";

export const companyInfo = createSlice({
  name: "companyInfo",
  initialState: {
    id: "",
    iconPath: "",
    logoPath: "",
    mailContent: "",
    isLoading: false,
  },
  reducers: {
    ClearCompanyInfoState(state, action) {
      state.iconPath = "";
      state.logoPath = "";
      state.id = "";
      state.mailContent = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(upsertCompanyInfo.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(upsertCompanyInfo.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(getCompanyInfo.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getCompanyInfo.fulfilled, (state, action) => {
      state.companyId = action.payload?.companyId;
      state.id = action.payload?.id;
      state.logoPath = action.payload?.logoPath;
      state.iconPath = action.payload?.iconPath;
      state.mailContent = action.payload?.mailContent;

      state.isLoading = false;
    });

    builder.addCase(deleteCompanyInfo.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteCompanyInfo.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(deleteImageFromCompanyInfo.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteImageFromCompanyInfo.fulfilled, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { UpdateCompanyId, ClearCompanyInfoState } = companyInfo.actions;

export default companyInfo.reducer;
